import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

export const UtilizationModalStyled = styled.div`
	min-width: 584px; /* this gives the modal a width of 700 if we add the padding */
	color: ${CSS_CONSTANTS.v2_text_gray};
`;

export const TopSection = styled.div`
	display: flex;
	justify-content: space-between;

	.person-name-container {
		display: flex;
		align-items: center;
		font-size: 20px;

		.person-name {
			margin-left: 10px;
			font-weight: 500;
			font-size: 20px;
			font-weight: 700;

			.utilization {
				font-weight: 100;
			}
		}
	}

	button {
		padding: 10px 16px;
	}
`;

export const StatsSection = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-top: 20px;
	padding: 15px;
	border-top: 3px solid ${CSS_CONSTANTS.v2_button_very_light_grey};
	border-bottom: 3px solid ${CSS_CONSTANTS.v2_button_very_light_grey};

	.stats-component {
		display: flex;
		flex-direction: column;
		align-items: center;

		.component-value {
			font-size: 18px;
			font-weight: 500;
			color: ${CSS_CONSTANTS.v2_text_gray};
			margin-top: 5px;

			.available {
				color: ${CSS_CONSTANTS.v2_text_light_gray};
			}
		}
	}

	.separator {
		height: 33px;
		width: 1px;
		background-color: ${CSS_CONSTANTS.v2_button_very_light_grey};
	}
`;

export const Subtitle = styled.div`
	font-size: 9px;
	letter-spacing: 1px;
	text-transform: uppercase;
	color: ${CSS_CONSTANTS.v2_text_light_gray};
`;

export const DistributionSection = styled.div`
	margin-top: 25px;

	.data-graph-container {
		display: flex;
		justify-content: space-between;

		.flex-container {
			display: flex;
			flex-direction: column;

			.utilization-data-section {
				margin-top: 5px;
				width: 350px;

				.utilization-data-section-header {
					border-bottom: 1px solid ${CSS_CONSTANTS.v2_button_very_light_grey};
					padding: 10px 0;
					font-size: 13px;
					font-weight: 500;
				}
				.utilization-data-section-row-container {
					padding: 14px 0;
					padding-bottom: 4px;
					a {
						text-decoration: none;
					}
					.utilization-data-section-row {
						display: flex;
						flex-direction: row;
						margin-bottom: 10px;
						align-items: center;
						.name {
							flex: 1;
							font-size: 12px;
							min-width: 120px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.minutes-allocated {
							flex: 0 0 100px;
							font-size: 12px;
							text-align: right;
						}
					}
					&.idle,
					&.time-off {
						.name {
							flex: 1 0 186px;
							margin-left: 0;
							width: 186px;
						}
					}
				}
			}
		}

		.graph-section {
			margin-left: 25px;
			.graph-header {
				font-size: 13px;
				font-weight: 500;
			}
			.graph {
				margin-top: 28px;
				margin-bottom: 22px;
				padding-left: 24px;
				position: relative;
				.graph-axis {
					width: 150px;
					height: 200px;
					border-left: solid 1px ${CSS_CONSTANTS.v2_button_very_light_grey};
					border-bottom: solid 1px ${CSS_CONSTANTS.v2_button_very_light_grey};
				}
				.graph-step {
					position: absolute;
					font-size: 10px;
					font-weight: 100;
					color: ${CSS_CONSTANTS.v2_text_light_gray};
					text-align: right;
					width: 100px;
					left: -86px;
					.infinity-sign-container {
						position: relative;
						.infinity-sign {
							position: absolute;
							background-image: url('images/components/scheduling/infinity-icon.svg');
							right: -2px;
							top: -12px;
							width: 16px;
							height: 8px;
							background-size: 16px 8px;
							background-position: right top;
							background-repeat: no-repeat;
						}
					}
					.line-container {
						position: relative;
						.line {
							position: absolute;
							height: 1px;
							width: 9px;
							bottom: 8px;
							right: -15px;
							background-color: ${CSS_CONSTANTS.v2_button_very_light_grey};
						}
					}
				}
				.working-hours-line {
					position: absolute;
					width: 150px;
					border-top: 1px dashed ${CSS_CONSTANTS.v2_button_very_light_grey};
					z-index: 100;
				}
				.graph-grey-block {
					position: absolute;
					bottom: 0;
					left: 74px;
					background-color: ${CSS_CONSTANTS.v2_button_very_light_grey};
					width: 50px;
				}
				.graph-green-block {
					position: absolute;
					bottom: 0;
					left: 74px;
					background-color: ${CSS_CONSTANTS.schedule_v2_green};
					width: 50px;
				}
				.graph-red-block {
					position: absolute;
					bottom: 0;
					left: 74px;
					background-color: ${CSS_CONSTANTS.schedule_v2_red};
					width: 50px;
				}
				.difference-text {
					position: absolute;
					font-size: 13px;
					width: 150px;
					text-align: center;
					margin-bottom: 5px;
					span {
						font-size: 11px;
					}
				}
				.graph-footer {
					position: absolute;
					width: 150px;
					text-align: center;
					font-size: 11px;
					font-weight: 500;
					letter-spacing: 1px;
					text-transform: uppercase;
					color: ${CSS_CONSTANTS.v2_text_light_gray};
					bottom: -24px;
					white-space: nowrap;
				}
			}
		}
	}
`;

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 13px;

	.message {
		margin-top: 15px;
		font-weight: 500;
	}
`;
